import React from "react";

interface PendingIconProps {
  fill?: string;
  size?: number | string;
}

const PendingIcon: React.FC<PendingIconProps> = ({ fill = "#fff", size }) => (
  <svg
    id="uuid-d7f676cd-ad72-44c7-a8f6-0bd466658f73"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 222.83 350"
    {...(size && { width: size, height: size })}
  >
    <g id="uuid-05366594-dd07-44ac-b3eb-e9356e19afec" data-name="Layer 1" transform="scale(0.75)">
      <g id="uuid-f6551605-cd45-4c3c-a75e-cd11774a489d" data-name="04-Pending">
        <path
          fill={fill}
          d="M111.41,433.69c-5.98,0-11.97-1.54-17.31-4.62l-76.8-44.34c-10.67-6.16-17.31-17.65-17.31-29.97v-88.68c0-12.33,6.63-23.81,17.31-29.98l33.34-19.25-33.34-19.25c-10.67-6.16-17.31-17.65-17.31-29.98v-88.68c0-12.33,6.63-23.81,17.31-29.97L94.11,4.62c10.67-6.16,23.94-6.16,34.61,0l76.8,44.34c10.67,6.16,17.31,17.65,17.31,29.98v88.68c0,12.33-6.63,23.81-17.31,29.97l-33.34,19.25,33.34,19.25c10.67,6.16,17.31,17.65,17.31,29.97v88.68c0,12.33-6.63,23.81-17.31,29.97l-76.8,44.34c-5.34,3.08-11.32,4.62-17.31,4.62ZM86.47,216.84c.03,4.18-2.12,8.25-6,10.49l-51.17,29.54c-3.27,1.89-5.31,5.41-5.31,9.19v88.68c0,3.78,2.03,7.3,5.31,9.19l76.8,44.34c3.27,1.89,7.34,1.89,10.61,0l76.8-44.34c3.27-1.89,5.31-5.41,5.31-9.19v-88.68c0-3.78-2.03-7.3-5.31-9.19l-51.17-29.54c-3.71-2.14-6-6.1-6-10.39v-.2c0-4.29,2.29-8.25,6-10.39l51.17-29.54c3.27-1.89,5.31-5.41,5.31-9.19v-88.68c0-3.78-2.03-7.3-5.31-9.19L116.72,25.41c-3.27-1.89-7.34-1.89-10.61,0L29.31,69.75c-3.27,1.89-5.31,5.41-5.31,9.19v88.68c0,3.78,2.03,7.3,5.31,9.19l51.17,29.54c3.88,2.24,6.03,6.31,6,10.49Z"
        />
        <path
          fill={fill}
          d="M107.59,270.75l-47.42,32.15c-2.77,1.87-4.47,5.34-4.47,9.09v18.97c0,3.75,1.7,7.21,4.47,9.09l47.42,32.15c2.77,1.87,6.17,1.87,8.94,0l47.42-32.15c2.77-1.87,4.47-5.34,4.47-9.09v-18.97c0-3.75-1.7-7.21-4.47-9.09l-47.42-32.15c-2.77-1.87-6.17-1.87-8.94,0Z"
        />
      </g>
    </g>
  </svg>
);

export default PendingIcon;
